import type { IconProps } from '../types/IconProps.ts';
export const MenuHorizontal: IconProps = {
    name: 'MenuHorizontal',
    children: [
        `<circle cx="5" cy="12" r="1" />`,
        `<circle cx="12" cy="12" r="1" />`,
        `<circle cx="19" cy="12" r="1" />`,
    ]
};